export default "__VITE_ASSET__xyP8q3FY__"